import * as React from 'react';

import base from './base';


const BaseBox = base('div');

export default class Box extends React.PureComponent {
  static Styled = BaseBox;

  render() {
    return React.createElement(BaseBox, this.props);
  }
}
